import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class PassageiroItemContratoService {
  private baseUrl = environment.baseUrl
  private resource = 'PassageiroItemContrato'

  constructor(private httpClient: HttpClient) {}

  public getDisponiveis(contratoId: any): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/disponiveis/${contratoId}`,
    )
  }

  public create(body: { passageiroId: string; itemContratoId: string }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create`, body)
  }

  public delete(passageiroId: string, itemContratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${passageiroId}/${itemContratoId}`,
      {},
    )
  }

  public deleteTodos(contratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete-todos/${contratoId}`,
      {},
    )
  }

  public getValidacaoLogistica(contratoId: any): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/validacao-logistica/${contratoId}`,
    )
  }
}
